import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { CurrencyDigitShortcutPipeInput } from 'src/app/pipes/pipes';
import { TranslatedCurrencyYearInputs, TranslatedCurrencyDigitInputs } from 'src/app/pipes/translated-currency-input-keys';
import { ModalService } from 'src/app/services/modal/modal.service';
import { InvestmentEdit } from 'src/app/services/rest-api/rest-api';
import { RestApiService } from 'src/app/services/rest-api/rest-api.service';
import { availableInvestmentPeriods } from 'src/app/shared/constants';
import { ConfigService } from 'src/app/services/json-config.service';
import { EnvironmentKeys } from 'src/environments/environment-keys';
import { UserService } from 'src/app/services/user/user.service';
import { AvailableCurrencySymbols, getCurrencyFromCode } from 'src/app/shared/functions';
import { CurrencyCodesEnum } from 'src/app/shared/charts/charts';

// todo - what is this component?
@Component({
  templateUrl: './money-deposit-edit.component.html',
  styleUrls: ['./money-deposit-edit.component.scss'],
  standalone: false
})
export class MoneyDepositEditComponent implements OnInit {
  public editForm!: UntypedFormGroup;
  public investmentData!: InvestmentEdit;
  public EnvironmentKeys = EnvironmentKeys;

  public yearsShortcutsOptions: CurrencyDigitShortcutPipeInput = {
    units: TranslatedCurrencyYearInputs
  }

  public digitShortcutsOptions: CurrencyDigitShortcutPipeInput = {
    digitShortcuts: TranslatedCurrencyDigitInputs
  }

  public get bothInvestmentsZero(): boolean {
    return this.editForm.value['initialDeposit'] + this.editForm.value['regularDeposit'] > 0;
  }

  public availableInvestmentPeriods = availableInvestmentPeriods;

  public constructor(
    private route: ActivatedRoute,
    private router: Router,
    private restApiService: RestApiService,
    private modalService: ModalService,
    public configService: ConfigService,
    public userService: UserService,
  ) { }

  public ngOnInit(): void {
    this.route.paramMap.pipe(take(1)).subscribe((params: ParamMap) => {
      const investmentId = params.get('id');
      if (investmentId) {
        this.loadData();
      } else {
        this.router.navigate(['/money/deposit']);
      }
    });
  }

  private loadData(): void {
    this.investmentData = this.restApiService.getInvestmentEdit();

    this.initForm();
  }

  private initForm(): void {
    this.editForm = new UntypedFormGroup({
      name: new UntypedFormControl(this.investmentData.name),
      initialDeposit: new UntypedFormControl(this.investmentData.initialDeposit),
      regularDeposit: new UntypedFormControl(this.investmentData.regularDeposit),
      totalYearsToInvest: new UntypedFormControl(this.investmentData.totalYearsToInvest),
      depositRegularity: new UntypedFormControl(this.investmentData.weeksBetweenInvestments),
    });
  }

  public getCurrencyFromCode(currencyCode: keyof typeof CurrencyCodesEnum): AvailableCurrencySymbols {
    return getCurrencyFromCode(currencyCode);
  }

  public openModal(): void {
    this.modalService.openMoneyDepositModal(1); // todo investment ID
  }
}
